import React from "react";
import { connect } from "react-redux";
import Drawer from 'devextreme-react/drawer';
import Toolbar, { Item } from "devextreme-react/toolbar";
import List from "devextreme-react/list";
import notify from 'devextreme/ui/notify';
import Form from "devextreme-react/form";
import ArrayStore from "devextreme/data/array_store";
import { ABECASUSER_LOGIN_TYPE } from "../../common/permissions";
import { alert } from 'devextreme/ui/dialog';
import Popup from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import PreviewGenerateCountRecords from "../gneratecountrecord/PreviewGenerateCountRecords";
//import CommitTransactionsPrintErrors from "../genaric-component/TransactionsPrintErrors";
import { Button } from 'devextreme-react/button';
import DataGrid, {
    Column,
    Editing,
    Lookup,
} from "devextreme-react/data-grid";
import Accordion from 'devextreme-react/accordion';
import axios from "axios";
import routes from "../../assets/apiRoutes.json";
import { LoadPanel } from 'devextreme-react/load-panel';
import { SelectBox, TextArea, TextBox } from "devextreme-react";

const searchpanel = [
    {
        ID: 1,
        Name: 'Search Filters'
    }
];
const list = React.createRef();
const dataGrid = React.createRef();
let ignoreListSelectionChange = false;
const orderByData = [
    { ID: 0, Text: "None" },
    { ID: 1, Text: "Ascending" },
    { ID: 2, Text: "Descending" },
];

const orderByDataSource = new ArrayStore({
    data: orderByData,
    key: "ID",
});

const prefixData = [
    { ID: 0, Text: "And" },
    { ID: 1, Text: "Or" },
];

const prefixDataSource = new ArrayStore({
    data: prefixData,
    key: "ID",
});
const groupData = [
    { ID: 0, Text: "No" },
    { ID: 1, Text: "Begin" },
    { ID: 2, Text: "End" },
];
const operationData = [
    { ID: 0, Text: "StartsWith" },
    { ID: 1, Text: "EndsWith" },
    { ID: 2, Text: "Contains" },
    { ID: 3, Text: "Equal" },
    { ID: 4, Text: "NotEqual" },
    { ID: 5, Text: "Greater" },
    { ID: 6, Text: "GreaterEqual" },
    { ID: 7, Text: "Less" },
    { ID: 8, Text: "LessEqual" },
    { ID: 9, Text: "Between" },
    { ID: 10, Text: "Includes" },
];

const groupDataSource = new ArrayStore({
    data: groupData,
    key: "ID",
});
const operationDataSource = new ArrayStore({
    data: operationData,
    key: "ID",
});

let accessToken = "";
class GenerateCountRecords extends React.Component {
    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;
        this.StartButtonClicked = this.StartButtonClicked.bind(this);
        this.previewButtonClicked = this.previewButtonClicked.bind(this);
        this.resetButtonClicked = this.resetButtonClicked.bind(this);
        this.selectionChanged = this.selectionChanged.bind(this);
        this.loadWMGenCountRecordsFields = this.loadWMGenCountRecordsFields.bind(this);
        this.dataFieldSelectionChanged = this.dataFieldSelectionChanged.bind(this);
        this.dataFieldRender = this.dataFieldRender.bind(this);
        this.ClearCountOrSkipItemsChanged = this.ClearCountOrSkipItemsChanged.bind(this);
        this.CreateTaskChanged = this.CreateTaskChanged.bind(this);
        this.SettingsValuesChanged = this.SettingsValuesChanged.bind(this);
        this.handelOpenLookupCountReferenceFrom = this.handelOpenLookupCountReferenceFrom.bind(this);
        this.handleClosePreviewPopUpCallback = this.handleClosePreviewPopUpCallback.bind(this);
        this.handleClosePrintErrorsPopUpCallback = this.handleClosePrintErrorsPopUpCallback.bind(this);
        this.LoadFromToDropDowns = this.LoadFromToDropDowns.bind(this);
        this.LoadActivityDropDown = this.LoadActivityDropDown.bind(this);
        this.LoadWorkerDropDown = this.LoadWorkerDropDown.bind(this);
        this.LoadWorkerDropDown = this.LoadWorkerDropDown.bind(this);
        this.openphysicalcountsetupPopup = this.openphysicalcountsetupPopup.bind(this);
        this.closephysicalcountsetupPopup = this.closephysicalcountsetupPopup.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
        this.RestartCountRecordsGenerationProcess = this.RestartCountRecordsGenerationProcess.bind(this);

        this.state = this.getInitialState(props);

        this.toolbarItems = [{
            widget: 'dxButton',
            location: 'right',
            options: {
                icon: 'menu',
                onClick: () => this.setState({ opened: !this.state.opened }),
            },
        }];
        this.loadWMGenCountRecordsFields();
    }
    getInitialState(props) {
        return {
            animationDuration: 300,
            selectedItems: [],
            isPreviewGridPopupVisible: false,
            isPrintPreviewPopupVisible: false,
            loadIndicatorVisible: false,
            IsphysicalcountsetupPopup: false,
            connection: null,
            ABErros: [],
            previewData: [],
            opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
            generatedFileName: "",
            report: {
                key: "",
                name: "",
                fullName: "",
                ignoreCompany: false,
                parameterList: [],
                queryParameters: [],
                whereInfoList: [],
                filterWhereInfoList: [
                ],
            },
            settings: {
                countdesc: '',
                requestedby: '',
                quantitybasis: "O",
                comment: '',
                clearcounts: "N",
                skipitems: "Y",
                fromcount: "",
                tocount: "",
                isFromDisabled: true,
                isToDisabled: true,
                createtask: 'N',
                workerArr: [],
                worker: '',
                isWorkerDisabled: true,
                activityArr: [],
                activity: '',
                isActivityDisabled: true,
                quantitybasisArr: [
                    { id: 1, name: 'Quantity On Hand', value: 'O' },
                    { id: 2, name: 'Quantity Available', value: 'A' },
                ],
                clearCountsArr: [
                    { id: 1, name: 'No, Do Not Delete Existing Open Count Records', value: 'N' },
                    { id: 2, name: 'Yes, Delete For Specified Open Count Reference #', value: 'Y' },
                    { id: 3, name: 'Yes, Delete All Existing Open Count Records', value: 'A' },
                ],
                skipItemsArr: [
                    { id: 1, name: 'Yes, Skip Item(s) That Are Already Included In A Current Count', value: 'Y' },
                    { id: 2, name: 'No, Do Not Skip Item(s) That Are Already Included In A Current Count', value: 'N' },
                ],
                createTaskArr: [
                    { id: 1, name: 'No', value: 'N' },
                    { id: 2, name: 'Yes', value: 'Y' },
                ],
                FromToArr: []
            },
            spresponse: {
                message: "",
                recordcount: "",
            },
            formData: {},
            formItems: [],
        };
    }
    LoadFromToDropDowns() {
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.GenCountRecords.GetCountReferenceNumber}`, "",
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                if (response.status == 200 && response.data.success) {
                    this.setState(prevState => ({
                        loadIndicatorVisible: false,
                        settings: {
                            ...prevState.settings,
                            FromToArr: response.data.resultdata,
                        },
                    }));
                }
                else {
                    notify({
                        message: 'Couldnt Load From/To Count Ref.',
                        width: 450,
                    }, 'error', 2000);
                    this.setState(prevState => ({
                        loadIndicatorVisible: false,
                        settings: {
                            ...prevState.settings,
                            FromToArr: [],
                        },
                    }));
                }
            });
    }
    LoadActivityDropDown() {
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.GenCountRecords.GetCAActivity}`, { name: "", description: "" },
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                if (response.status == 200 && response.data.success) {
                    this.setState(prevState => ({
                        loadIndicatorVisible: false,
                        settings: {
                            ...prevState.settings,
                            activityArr: response.data.resultdata,
                        },
                    }));
                }
                else {
                    notify({
                        message: 'Couldnt Load Activity',
                        width: 450,
                    }, 'error', 2000);
                    this.setState(prevState => ({
                        loadIndicatorVisible: false,
                        settings: {
                            ...prevState.settings,
                            activityArr: [],
                        },
                    }));
                }
            });
    }
    LoadWorkerDropDown() {
        let request = {
            identityIdFrom: '',
            lookupType: 6,
            isAutoComplete: false,
        };
        axios
            .post(
                `${window._env_.REACT_APP_APIS}/${routes.Receipt.SearchLookup}`,
                request,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
            .then((resp) => {
                this.setState(prevState => ({
                    loadIndicatorVisible: false,
                    settings: {
                        ...prevState.settings,
                        workerArr: resp.data.lookups,
                    },
                }));
            });
    }
    ClearCountOrSkipItemsChanged(ctrlName, value) {
        this.setState((prvState) => {
            const updatedSettings = { ...prvState.settings, [ctrlName]: value };
            if (ctrlName == 'clearcounts') {
                const isDisabled = value == 'N' || value == 'A';
                updatedSettings.isFromDisabled = isDisabled;
                updatedSettings.isToDisabled = isDisabled;
                updatedSettings.tocount = '';
                updatedSettings.fromcount = '';
            }
            return { settings: updatedSettings };
        });
    }
    CreateTaskChanged(e) {
        const isDisabled = e.value == 'N';
        this.setState((prvState) => ({
            settings: {
                ...prvState.settings,
                isWorkerDisabled: isDisabled,
                isActivityDisabled: isDisabled,
                worker: '',
                activity: '',
                createtask: e.value,
            },
        }));
    }
    SettingsValuesChanged(ctrlName, value) {
        this.setState(prvState => ({
            settings: {
                ...prvState.settings,
                [ctrlName]: value,
            }
        }));
    }
    handelOpenLookupCountReferenceFrom() {
        this.setState({
            openLookupCountReferenceFrom: true,
        });
    }
    handleClosePreviewPopUpCallback() {
        this.setState({
            isPreviewGridPopupVisible: false,
        });
    };
    handleClosePrintErrorsPopUpCallback() {
        this.setState({
            isPrintPreviewPopupVisible: false,
        });
    };
    printErrorsButtonClicked = async () => {
        this.setState({
            isPrintPreviewPopupVisible: true,
        });
        this.setState({
            loadIndicatorVisible: true
        });
        const data = await this.GetABErrorswData();
        this.setState({
            ABErros: data,
            isPrintPreviewPopupVisible: true,
            loadIndicatorVisible: false
        });
    }
    GetABErrorswData = async () => {
        try {
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.GenCountRecords.GetABErrorsHeaders}`,
                JSON.stringify("GenCntRcWM"),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            this.setState({
                loadIndicatorVisible: false
            });
            console.error('Error when fetching Generate Count Record ABErrorsHeaders data:', error);
            throw error;
        }
    };
    RestartCountRecordsGenerationProcess() {
        this.closephysicalcountsetupPopup();
        this.StartButtonClicked(null, true);
    }
    StartButtonClicked(e, flag) {
        try {
            if (e != null && e != undefined)
                e.event.stopPropagation();
            this.setState({
                loadIndicatorVisible: true,
            });
            let request = {
                filterWhereInfoList: this.state.report.filterWhereInfoList,
                Isphysicalcountsetup: flag,
                Module:this.props.module,
                ...this.state.settings
            };
            axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.GenCountRecords.GenerateCountRecordsStart}`,
                JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            ).then((response) => {
                if (response.data.success) {
                    this.setState({
                        loadIndicatorVisible: false,
                    });
                    if (response.data.resultdata?.isphysicalcountsetuperror) {
                        //this.openphysicalcountsetupPopup();
                        alert(
                            `<h6>Transaction Number Generation Format has not been set up in Abecas insight. Cant proceed. </h6>`,
                            "Error Message"
                        ).then(() => {
                            return;
                        });
                    }
                    if (response.data.resultdata?.israngeselectionvaliderror) {
                        notify({
                            message: response.data.message,
                            width: 500,
                        }, 'error', 5000);
                    }
                    if (response.data.resultdata?.isverfyItemsnotinexistingcounterror) {
                        notify({
                            message: response.data.message,
                            width: 500,
                        }, 'error', 5000);
                    }
                    if (response.data.resultdata?.iscalltosperror == "No") {
                        let iCount = response.data.resultdata.transactioncount;
                        let SkippedCount = response.data.resultdata.misseditemscount;
                        let CountReference = response.data.resultdata.countrefnumber;

                        if (SkippedCount > 0) {
                            alert(
                                `<h5>${iCount + " Item(s) were inserted and " + SkippedCount +
                                " item(s) that are already includded in a current count were skipped."}</h5>`,
                                "Process Complete"
                            ).then(() => {
                                if (iCount > 0) {
                                    alert(
                                        `<h5>${CountReference ? "Count Reference # - " + CountReference : "Count Records Generated"}</h5><h6>Records Processed: ${iCount}</h6>`,
                                        "Process Complete"
                                    );
                                }
                            });
                        }
                        else {
                            if (iCount > 0) {
                                alert(
                                    `<h5>${CountReference ? "Count Reference # - " + CountReference : "Count Records Generated"}</h5><h6>Records Processed: ${iCount}</h6>`,
                                    "Process Complete"
                                );
                            }
                        }
                    }
                    else {
                        if (response.data.resultdata?.iscalltosperror) {
                            notify({
                                message: response.data.message,
                                width: 500,
                            }, 'error', 5000);
                        }
                    }
                }
                else {
                    notify({
                        message: response.data.message,
                        width: 500,
                    }, (response.data.success ? 'success' : 'error'), 5000);
                }
            }).catch((err) => {
                this.setState({
                    loadIndicatorVisible: false
                });
                notify({
                    message: 'Couldnt Load Data!!',
                    width: 450,
                }, 'error', 2000);
            }).finally(() => {
                this.setState({
                    loadIndicatorVisible: false
                });
            });
        }
        catch (error) {
            notify({
                message: 'Generating Count Records Process Failed.',
                width: 450,
            }, 'error', 2000);
            console.error('Error Generating Count Records.', error);
        }
        finally {
            this.setState({
                loadIndicatorVisible: false,
            });
        }
    }
    async previewButtonClicked(e) {
        if (e != null && e != undefined)
            e.event.stopPropagation();
        this.setState({
            loadIndicatorVisible: true
        });
        const data = await this.PreviewData();
        this.setState({
            previewData: data.resultdata,
            isPreviewGridPopupVisible: true,
            loadIndicatorVisible: false
        });
    }
    PreviewData = async () => {
        try {
            let filterWhereInfoList = { filterWhereInfoList: this.state.report.filterWhereInfoList, quantitybasis: this.state.settings.quantitybasis,Module:this.props.module};
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.GenCountRecords.GetCountRecordsPreviewData}`,
                JSON.stringify(filterWhereInfoList),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            this.setState({
                loadIndicatorVisible: false
            });
            console.error('Error Getting Transaction Data:', error);
            throw error;
        }
    }
    resetButtonClicked(e) {
        e.event.stopPropagation();
        this.setState(this.getInitialState(this.props), () => {
            this.loadWMGenCountRecordsFields();
        });
    }
    selectionChanged(e) {
        let newItems = [...this.state.selectedItems];
        e.removedItems.forEach((item) => {
            const index = newItems.indexOf(item);
            if (index >= 0) {
                newItems.splice(index, 1);
            }
        });
        if (e.addedItems.length) {
            newItems = [...newItems, ...e.addedItems];
        }
        this.setState({
            selectedItems: newItems
        });
    }
    dataFieldRender(e) {
        var dataSource = dataGrid.current.instance().getDataSource();
        if (dataSource != null && dataSource._items != null) {
            var found = dataSource._items.find(i => i.origin == e.itemData.origin);
            if (found != null && found != undefined) {
                if (!e.component.isItemSelected(e.itemIndex)) {
                    ignoreListSelectionChange = true;
                    e.component.selectItem(e.itemIndex);
                    ignoreListSelectionChange = false;
                }
            }
        }
    }
    dataFieldSelectionChanged(e) {
        if (!ignoreListSelectionChange) {
            if (e.addedItems != null && e.addedItems.length === 1) {
                var dataSource = dataGrid.current.instance().getDataSource();
                dataSource
                    .store()
                    .insert(e.addedItems[0])
                    .done(function (dataObj, key) {
                        dataSource.reload();
                    })
                    .fail(function (error) {
                        alert(error);
                    });
            }

            if (e.removedItems != null && e.removedItems.length === 1) {
                var dataSource = dataGrid.current.instance().getDataSource();
                dataSource
                    .store()
                    .remove(e.removedItems[0].displayLabel)
                    .done(function (dataObj, key) {
                        dataSource.reload();
                    })
                    .fail(function (error) {
                        alert(error);
                    });
            }
        }
    }
    loadWMGenCountRecordsFields() {
        var that = this;
        axios
            .get(
                `${window._env_.REACT_APP_APIS}/${routes.reports.GetReport}?reportName=${'GENERATECOUNTRECORDS'}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
            .then((res) => {

                for (
                    var i = 0;
                    res.data.filterWhereInfoList != null &&
                    i < res.data.filterWhereInfoList.length;
                    i++
                ) {
                    switch (res.data.filterWhereInfoList[i].fieldType) {
                        case 5: // Flag
                            for (
                                var j = 0;
                                res.data.filterWhereInfoList[i].items != null && j < res.data.filterWhereInfoList[i].items.length;
                                j++
                            ) {

                                if (res.data.filterWhereInfoList[i].from == res.data.filterWhereInfoList[i].items[j].value) {
                                    res.data.filterWhereInfoList[i].from = res.data.filterWhereInfoList[i].items[j].text;
                                }

                                if (res.data.filterWhereInfoList[i].to == res.data.filterWhereInfoList[i].items[j].value) {
                                    res.data.filterWhereInfoList[i].to = res.data.filterWhereInfoList[i].items[j].text;
                                }
                            }
                            break;
                        default:
                    }
                }

                for (
                    var i = 0;
                    res.data.whereInfoList != null &&
                    i < res.data.whereInfoList.length;
                    i++
                ) {
                    switch (res.data.whereInfoList[i].fieldType) {
                        case 5: // Flag
                            for (
                                var j = 0;
                                res.data.whereInfoList[i].items != null && j < res.data.whereInfoList[i].items.length;
                                j++
                            ) {

                                if (res.data.whereInfoList[i].from == res.data.whereInfoList[i].items[j].value) {
                                    res.data.whereInfoList[i].from = res.data.whereInfoList[i].items[j].text;
                                }

                                if (res.data.whereInfoList[i].to == res.data.whereInfoList[i].items[j].value) {
                                    res.data.whereInfoList[i].to = res.data.whereInfoList[i].items[j].text;
                                }
                            }
                            break;
                        default:
                    }
                }

                that.setState({
                    report: res.data,
                });

                var formData = new Object();

                var formItems = [];

                for (
                    var i = 0;
                    that.state.report.parameterList != null &&
                    i < that.state.report.parameterList.length;
                    i++
                ) {
                    formData[that.state.report.parameterList[i].name] =
                        that.state.report.parameterList[i].value;
                    var formItem = new Object();
                    formItem.dataField = that.state.report.parameterList[i].name;
                    formItem.label = new Object();
                    formItem.label.text = that.state.report.parameterList[i].label;
                    switch (that.state.report.parameterList[i].parameterType) {
                        case 1: // Integer
                        case 2: // Decimal
                            formItem.editorType = "dxNumberBox";
                            break;
                        case 3: // Boolean
                            formItem.editorType = "dxCheckBox";
                            break;
                        case 4: // DateTime
                            formItem.editorType = "dxDateBox";
                            break;
                        case 5: // Flag
                            formItem.editorType = "dxSelectBox";
                            formItem.editorOptions = new Object();
                            formItem.editorOptions.items = [];

                            for (
                                var j = 0;
                                j < that.state.report.parameterList[i].items.length;
                                j++
                            ) {
                                var selectBoxItem = new Object();
                                selectBoxItem.Value =
                                    that.state.report.parameterList[i].items[j].value;
                                selectBoxItem.Text =
                                    that.state.report.parameterList[i].items[j].text;
                                formItem.editorOptions.items.push(selectBoxItem);
                            }

                            formItem.editorOptions.displayExpr = "Text";
                            formItem.editorOptions.valueExpr = "Value";
                            break;
                        default:
                            formItem.editorType = "dxTextBox";
                    }

                    formItems.push(formItem);
                }

                that.setState({
                    formData: formData,
                });

                that.setState({
                    formItems: formItems,
                });

                var dataFilterDataSource = new ArrayStore({
                    data: that.state.report.filterWhereInfoList,
                    key: "displayLabel",
                });

                dataGrid.current.instance().option("dataSource", dataFilterDataSource);


                ignoreListSelectionChange = true;
                for (var i = 0; res.data.whereInfoList != null && i < res.data.whereInfoList.length; i++) {
                    for (var j = 0; res.data.filterWhereInfoList != null && j < res.data.filterWhereInfoList.length; j++) {
                        if (res.data.whereInfoList[i].origin == res.data.filterWhereInfoList[j].origin) {
                            if (!list.current.instance().isItemSelected(i)) {
                                list.current.instance().selectItem(i);
                            }
                            break;
                        }
                    }
                }
                ignoreListSelectionChange = false;
            })
            .catch((err) => {
                console.log(err, "Error getting data");
            });
        this.LoadFromToDropDowns();
        this.LoadActivityDropDown();
        this.LoadWorkerDropDown();
    }
    openphysicalcountsetupPopup() {
        this.setState({ IsphysicalcountsetupPopup: true });
    }
    closephysicalcountsetupPopup() {
        this.setState({ IsphysicalcountsetupPopup: false });
    }
    handleFocusOut() {
        const { clearcounts, tocount, fromcount } = this.state.settings;
        if (clearcounts == "Y" && tocount && fromcount) {
            if (tocount.localeCompare(fromcount) < 0) {
                alert(
                    `<h5>The From Reference Number should be lower than the To Reference Number.</h5>`,
                    "Error Message"
                );
            }
        }
    };
    render() {
        return (
            <>
                <div id="generate-count-records">
                    <div className="row ">
                        <div className="col-md-12 main-page">
                            <div id="accordion" >
                                <Accordion
                                    dataSource={searchpanel}
                                    collapsible={true}
                                    multiple={false}
                                    animationDuration={this.state.animationDuration}
                                    selectedItems={this.state.selectedItems}
                                    onSelectionChanged={this.selectionChanged}
                                    itemTitleRender={() => (
                                        <Toolbar className="accordian-toolbar">
                                            <Item location="before">
                                                <div className="title">
                                                    <h6 style={{ color: window._env_.Color2 }}>
                                                        Generate Count Records
                                                    </h6>
                                                </div>
                                            </Item>
                                            <Item location="after">
                                                <Button className="accordianButton" onClick={(e) => this.StartButtonClicked(e, false)} text="Start" type="default" />
                                            </Item>
                                            <Item location="after">
                                                <Button className="accordianButton" onClick={(e) => this.previewButtonClicked(e)} text="Preview" />
                                            </Item>
                                            <Item location="after">
                                                <Button className="accordianButton" onClick={this.resetButtonClicked} text="Reset" />
                                            </Item>
                                            {
                                                /*<Item location="after">
                                                    <Button className="accordianButton" onClick={this.printErrorsButtonClicked} text="Print Errors" />
                                                </Item>*/
                                            }
                                        </Toolbar>
                                    )}
                                    itemRender={(itemProps) => (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <fieldset className="h-100">
                                                    <legend className="h6">Settings 1</legend>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <TextBox
                                                                className="light-ui-textbox"
                                                                label="Count Desc"
                                                                maxLength={40}
                                                                value={this.state.settings.countdesc}
                                                                onValueChanged={(e) => this.SettingsValuesChanged("countdesc", e.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <TextBox
                                                                className="light-ui-textbox"
                                                                label="Requested By"
                                                                maxLength={40}
                                                                value={this.state.settings.requestedby}
                                                                onValueChanged={(e) => this.SettingsValuesChanged("requestedby", e.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 py-2">
                                                            <SelectBox
                                                                dataSource={this.state.settings.quantitybasisArr}
                                                                value={this.state.settings.quantitybasis}
                                                                valueExpr='value'
                                                                displayExpr='name'
                                                                className="light-ui-textbox"
                                                                label="Quantity Basis"
                                                                onValueChanged={(e) => this.SettingsValuesChanged("quantitybasis", e.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 py-2">
                                                            <TextArea
                                                                className="light-ui-textbox"
                                                                label="Comment"
                                                                value={this.state.settings.comment}
                                                                onValueChanged={(e) => this.SettingsValuesChanged("comment", e.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="h-100">
                                                    <legend className="h6">Settings 2</legend>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <SelectBox
                                                                dataSource={this.state.settings.clearCountsArr}
                                                                value={this.state.settings.clearcounts}
                                                                valueExpr='value'
                                                                displayExpr='name'
                                                                className="light-ui-textbox"
                                                                label="Clear Counts"
                                                                onValueChanged={(e) => this.ClearCountOrSkipItemsChanged("clearcounts", e.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <SelectBox
                                                                dataSource={this.state.settings.skipItemsArr}
                                                                value={this.state.settings.skipitems}
                                                                valueExpr='value'
                                                                displayExpr='name'
                                                                className="light-ui-textbox"
                                                                label="Skip Item(s)"
                                                                onValueChanged={(e) => this.ClearCountOrSkipItemsChanged("skipitems", e.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 py-2">
                                                            <SelectBox
                                                                dataSource={this.state.settings.FromToArr}
                                                                value={this.state.settings.fromcount}
                                                                valueExpr='countreferencenumber'
                                                                displayExpr='countreferencenumber'
                                                                className="light-ui-textbox"
                                                                label="From"
                                                                disabled={this.state.settings.isFromDisabled}
                                                                onValueChanged={(e) => this.SettingsValuesChanged("fromcount", e.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 py-2">
                                                            <SelectBox
                                                                dataSource={this.state.settings.FromToArr}
                                                                value={this.state.settings.tocount}
                                                                valueExpr='countreferencenumber'
                                                                displayExpr='countreferencenumber'
                                                                className="light-ui-textbox"
                                                                label="To"
                                                                disabled={this.state.settings.isToDisabled}
                                                                onValueChanged={(e) => this.SettingsValuesChanged("tocount", e.value)}
                                                                onFocusOut={this.handleFocusOut}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 py-2">
                                                            <SelectBox
                                                                dataSource={this.state.settings.createTaskArr}
                                                                value={this.state.settings.createtask}
                                                                valueExpr='value'
                                                                displayExpr='name'
                                                                className="light-ui-textbox"
                                                                label="Create Task"
                                                                onValueChanged={this.CreateTaskChanged}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 py-2">
                                                            <SelectBox
                                                                dataSource={this.state.settings.workerArr}
                                                                value={this.state.settings.worker}
                                                                valueExpr='rowid'
                                                                displayExpr='identityId'
                                                                className="light-ui-textbox"
                                                                label="Worker"
                                                                disabled={this.state.settings.isWorkerDisabled}
                                                                onValueChanged={(e) => this.SettingsValuesChanged("worker", e.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 py-2">
                                                            <SelectBox
                                                                dataSource={this.state.settings.activityArr}
                                                                value={this.state.settings.activity}
                                                                valueExpr='rowid'
                                                                displayExpr='activity'
                                                                className="light-ui-textbox"
                                                                label="Activity"
                                                                disabled={this.state.settings.isActivityDisabled}
                                                                onValueChanged={(e) => this.SettingsValuesChanged("activity", e.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </div>
                                    )}
                                    id="accordion-container" className="accordion-height"
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ minWidth: "900px" }}>
                        <Form
                            id="form"
                            labelMode="static"
                            labelLocation="left"
                            formData={this.state.formData}
                            items={this.state.formItems}
                            colCount={5}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className={this.state.opened ? 'toolbar-holder' : 'toolbar-holder collapse-drawer '}>
                        <Toolbar items={this.toolbarItems} />
                    </div>
                </div>
                <div className="row bg-white">
                    <div>
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            onHiding={(() => this.setState({ loadIndicatorVisible: false }))}
                            visible={this.state.loadIndicatorVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <Drawer
                            opened={this.state.opened}
                            openedStateMode={'shrink'}
                            position={'left'}
                            revealMode={'slide'}
                            render={() =>
                                <List
                                    ref={list}
                                    dataSource={this.state.report.whereInfoList}
                                    pageLoadMode="scrollBottom"
                                    style={{ backgroundColor: '#F6F7FB' }}
                                    displayExpr="displayLabel"
                                    searchEnabled={true}
                                    searchExpr="displayLabel"
                                    showSelectionControls={true}
                                    selectionMode="multiple"
                                    onSelectionChanged={this.dataFieldSelectionChanged}
                                    onItemRendered={this.dataFieldRender}
                                ></List>}
                            closeOnOutsideClick={false}
                            className={this.state.selectedItems.length>0? "ReportFilterPanelHeightAccordionOpen" : "GridHeightTabPanel-with-toolbar"}>
                            <div>
                                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                                    id="gridContainer"
                                    ref={dataGrid}
                                    showBorders={true}
                                    className={this.state.selectedItems.length>0?(this.state.formItems.length>0?"WMReportGridHeightWithAccordianDouble":"WMRTGridStyle"):"WMReportGridStyle-AccordianClosed"}
                                    rowAlternationEnabled={true}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    onEditorPreparing={this.editorPreparing}
                                    onCellClick={this.CellClik}
                                >
                                    <Editing
                                        mode="cell"
                                        newRowPosition="last"
                                        refreshMode="repaint"
                                        allowUpdating={true}
                                        useIcons={true}
                                    />
                                    <Column
                                        dataField="displayLabel"
                                        caption="Display Label"
                                        allowEditing={false}
                                    />
                                    <Column dataField="orderBy" caption="Order By">
                                        <Lookup
                                            dataSource={orderByDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="prefix" caption="Prefix">
                                        <Lookup
                                            dataSource={prefixDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="group" caption="Group">
                                        <Lookup
                                            dataSource={groupDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="operation" caption="Operation">
                                        <Lookup
                                            dataSource={operationDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="from" caption="From" />
                                    <Column dataField="to" caption="To" />
                                    <Column caption="" allowEditing={false} cellRender={this.searchPopupCellRender} />
                                </DataGrid>
                            </div>
                        </Drawer>
                    </div>
                </div>
                {this.state.isPreviewGridPopupVisible &&
                    <Popup
                        visible={this.state.isPreviewGridPopupVisible}
                        onHiding={this.handleClosePreviewPopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title={"Preview"}
                        container=".dx-viewport"
                        closeOnOutsideClick={true}
                    >
                        <ScrollView width="100%" height="100%">
                            <PreviewGenerateCountRecords dataSource={this.state.previewData} />
                        </ScrollView>
                    </Popup>
                }
                {this.state.isPrintPreviewPopupVisible &&
                    <Popup
                        visible={this.state.isPrintPreviewPopupVisible}
                        onHiding={this.handleClosePrintErrorsPopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title={"Print Errors"}
                        container=".dx-viewport"
                        closeOnOutsideClick={true}
                    >
                        <ScrollView width="100%" height="100%">
                            {/* <CommitTransactionsPrintErrors dataSource={this.state.ABErros} reportname="ABR003" reportformat="Standard Abecas" />*/}
                        </ScrollView>
                    </Popup>
                }
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(GenerateCountRecords);
